export default "__VITE_ASSET__9d425ab2__"